module.exports = __webpack_public_path__ + "static/img/Jeremiah-Matautia.f869cbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremiah-Matautia.jpg
// module id = EXgs
// module chunks = 0